import { mountApplication } from "./ui/index.js"

mountApplication(document.getElementById("root"))
